import { Button } from 'nhsuk-react-components';
import { MouseEventHandler, useState } from 'react';
import Confirm from 'components/Confirm';
import { SUMMARY_REPORT_REVIEW_STATUSES } from 'schemas/SummaryReport.schema';
import usePatchReportReview from 'queries/mutate/patchReportReview.ts';
import Alert from 'components/Alert';
import { API_REJECT_SUMMARY_REPORT_ERROR } from 'constants/errorMessages';

interface IRejectSummaryReportProps {
  teamId: string,
  campaignId: string,
  iterationId: string,
  batchId: string;
}

function RejectSummaryReport({
  campaignId,
  iterationId,
  teamId,
  batchId,
}: IRejectSummaryReportProps) {
  const [isShowingRejectDialog, setIsShowingRejectDialog] = useState(false);
  const patchReportReview = usePatchReportReview();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const onClickReject: MouseEventHandler = () => {
    setIsShowingRejectDialog(true);
  };

  const abort = () => {
    setIsShowingRejectDialog(false);
  };

  const confirm = async () => {
    setIsShowingRejectDialog(false);

    try {
      await patchReportReview.mutateAsync({
        campaignId,
        iterationId,
        teamId,
        batchId,
        summaryReportPatch: {
          SUMMARY_REPORT_REVIEW: { STATUS: SUMMARY_REPORT_REVIEW_STATUSES.report_rejected },
        },
      });
    } catch {
      setErrorMessage(API_REJECT_SUMMARY_REPORT_ERROR);
    }
  };

  const isSubmitting = patchReportReview.isPending;

  return (
    <>
      <Button
        onClick={onClickReject}
        warning
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Updating...' : 'Reject report'}
      </Button>
      {isShowingRejectDialog && (
        <Confirm
          title="Reject summary report?"
          message="Rejecting this report will return the iteration to draft. You’ll need to get it approved again and request a new summary report. Are you sure you want to reject it?"
          yesText="Yes, reject report"
          noText="No, return to report"
          onYes={confirm}
          onNo={abort}
        />
      )}
      {errorMessage && (
        <div className="nhsuk-u-margin-top-3 nhsuk-u-width-full">
          <Alert
            title="Unable to reject report"
            message={errorMessage}
            onClose={() => setErrorMessage(null)}
          />
        </div>
      )}
    </>
  );
}
export default RejectSummaryReport;
